import { Box, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import React from "react";

const InfoCircle: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Tooltip label={text} position="top" withArrow>
      <Box c="blue.5" aria-label="Info">
        <IconInfoCircle size={20} />
      </Box>
    </Tooltip>
  );
};

export default InfoCircle;
